import { TileIndex } from "../../types";

export const ATTACK: TileIndex[][] = [
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 25, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 16, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 18, 18, 18, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 27, 0, 0, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 0, 0, 27, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 27, 0, 0, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 0, 0, 27, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 27, 0, 0, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 0, 0, 27, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 27, 0, 0, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 0, 0, 27, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 27, 0, 0, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 30, 26, 0, 0, 27, 2, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 1, 1, 1, 1, 0, 1, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 12, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 19, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 32, 1, 1, 1, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 0, 0, 0, 1],
  [1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 15, 0, 0, 0, 1],
  [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
];
